// tienda/BeneficiosSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { Clock, HandCoins, MapPin, MessageSquare, PhoneCall, Truck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const ITEMS = [
  { icon: <Truck className="size-5" />, title: "Niveles por pedido", text: "Usa Clásico, Coordinado o Premium según el valor, urgencia y riesgo de cada entrega." },
  { icon: <PhoneCall className="size-5" />, title: "Más coordinación", text: "Coordinado combina automatización y apoyo humano para reducir fricción con el destinatario." },
  { icon: <HandCoins className="size-5" />, title: "COD completo", text: "Cobramos por ti con los medios habilitados, manejamos efectivo y conciliamos cada monto." },
  { icon: <MapPin className="size-5" />, title: "Tracking para todos", text: "Tu equipo y el cliente final ven resumen, estado y ubicación cuando esté disponible." },
  { icon: <MessageSquare className="size-5" />, title: "Cliente final informado", text: "Mensajes automáticos y una interfaz clara reducen preguntas manuales por WhatsApp." },
  { icon: <Clock className="size-5" />, title: "Reintento inteligente", text: "Coordinado y Premium incluyen reintento en distritos elegibles, validado automáticamente." },
];

export function BeneficiosSection() {
  return (
    <section id="beneficios" className="border-b bg-white scroll-mt-16" style={{ borderColor: brand.line }}>
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-14 md:grid-cols-[0.8fr_1.2fr] md:py-20">
        <motion.div {...fadeUp}>
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Calidad operativa
          </p>
          <h2 className="text-3xl font-black leading-tight md:text-4xl" style={{ color: brand.ink }}>
            Menos rechazos. Más entregas efectivas. Más control para tu tienda.
          </h2>
          <p className="mt-4 text-sm leading-relaxed md:text-base" style={{ color: brand.muted }}>
            Fast Max reúne tecnología, COD, inventario, tracking y coordinación para que cada
            pedido tenga el nivel operativo que necesita sin prometer resultados imposibles.
          </p>
        </motion.div>

        <div className="grid gap-3 sm:grid-cols-2">
          {ITEMS.map((item, index) => (
            <motion.div
              key={item.title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.04 }}
              className="rounded-2xl border bg-white p-5 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-4 grid size-11 place-items-center rounded-xl" style={{ background: `${brand.primary}12`, color: brand.primary }}>
                {item.icon}
              </div>
              <h3 className="text-sm font-black" style={{ color: brand.ink }}>{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed" style={{ color: brand.muted }}>{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
